import { instance } from "../axios/axiosConfig";
import { AxiosRequestConfig } from "axios";
import {
  CreatorBrief,
  CreateCreatorBriefPayload,
  UpdateCreatorBriefPayload,
  DownloadCreatorBriefsBody,
} from "../types/creatorBriefsTypes.tsx";

const creatorBriefsApi = {
  fetchCreatorBriefs() {
    return instance.get<CreatorBrief[]>(`/api/creator-briefs/`);
  },

  fetchCreatorBriefById(id: string | number, config?: AxiosRequestConfig) {
    return instance.get<CreatorBrief>(`/api/creator-briefs/${id}/`, config);
  },

  createCreatorBrief(data: CreateCreatorBriefPayload) {
    return instance.post<CreatorBrief>(`/api/creator-briefs/`, data);
  },

  updateCreatorBrief(id: string | number, data: UpdateCreatorBriefPayload) {
    return instance.patch<CreatorBrief>(`/api/creator-briefs/${id}/`, data);
  },

  deleteCreatorBrief(id: string | number) {
    return instance.delete(`/api/creator-briefs/${id}/`);
  },

  downloadCreatorBrief(body: DownloadCreatorBriefsBody) {
    return instance.get(`/api/creator-briefs/${body.id}/download/`, {
      params: body.params,
      responseType: "blob",
    });
  },
};

export default creatorBriefsApi;
